import React from 'react';
import img01 from '../assests/img/cat-01.png';
import img02 from '../assests/img/cat-02.png';
import img03 from '../assests/img/cat-03.png';
import img04 from '../assests/img/cat-04.png';
import img05 from '../assests/img/cat-05.png';
import img06 from '../assests/img/cat-06.png';
import img07 from '../assests/img/cat-07.png';
import img08 from '../assests/img/cat-08.png';
import img09 from '../assests/img/cat-09.png';
import img10 from '../assests/img/cat-10.png';
import img11 from '../assests/img/cat-11.png';
import img12 from '../assests/img/cat-12.png';

const featuredCategories = [
  { name: 'Drones & Accessories', image: img01 },
  { name: 'Phones, Tablets & Accessories', image: img02 },
  { name: 'Laptops & Computers', image: img03 },
  { name: 'Power Banks & Chargers', image: img04 },
  { name: 'Apple Products', image: img05 },
  { name: 'Wearable Cameras & Action Cams', image: img06 },
  { name: 'Gaming Consoles', image: img07 },
  { name: 'Home Appliances', image: img08 },
  { name: 'Televisions & Home Theater', image: img09 },
  { name: 'Game Controller', image: img10 },
  { name: 'Storage & Digital Devices', image: img11 },
  { name: 'Audio Equipment', image: img12 },
];

function About() {
  return (
    <>
      <section className="home-featured-categories">
        <div className="container">
          <div className="featured-category-grid">
            {featuredCategories.map(category => (
                <div className="featured-category-card" key={category.name}>
                  <div className="featured-category-image-wrap">
                    <img
                      className="featured-category-image"
                      src={category.image}
                      alt={category.name}
                    />
                  </div>
                  <p>{category.name}</p>
                </div>
            ))}
          </div>
        </div>
      </section>     
    </>
  );
}

export default About;
